import { Baby, Clock, TrendingUp, BookOpen, Flame, Target } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";

const CARDS = [
  { icon: Clock, label: "Temps d'apprentissage" },
  { icon: TrendingUp, label: "Progression" },
  { icon: BookOpen, label: "Sourates apprises" },
  { icon: Flame, label: "Série" },
  { icon: Target, label: "Objectifs" },
];

export default function Parent() {
  useSeo("Espace Parent", "Espace parent Quran Coach : suis le temps d'apprentissage, la progression, les sourates apprises et les objectifs de tes enfants.");
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-black text-slate-800">Espace Parent</h1>
        <p className="text-slate-500">Suis la progression de tes enfants en un coup d'œil.</p>
      </div>

      <div className="bg-gradient-to-br from-secondary to-primary rounded-3xl p-8 text-white text-center relative overflow-hidden">
        <div className="absolute inset-0 islamic-star-pattern opacity-30" />
        <div className="relative">
          <Baby className="w-12 h-12 mx-auto mb-3" />
          <h2 className="text-2xl font-black mb-2">Bientôt disponible</h2>
          <p className="text-white/80 max-w-md mx-auto">L'association de profils enfants à votre compte parent arrive dans une prochaine mise à jour. L'architecture est déjà prête.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 opacity-60">
        {CARDS.map((c) => (
          <div key={c.label} className="bg-white p-5 rounded-3xl border border-dashed border-slate-200 flex flex-col items-center gap-2 text-center" data-testid={`parent-card-${c.label}`}>
            <div className="w-12 h-12 rounded-2xl bg-slate-100 text-slate-400 flex items-center justify-center"><c.icon className="w-6 h-6" /></div>
            <span className="text-sm font-bold text-slate-500">{c.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
